var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeldingAndCutting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.25,
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_354_706",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_354_706",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACnElEQVR4nO3cT24TMRTHcbccAXbAonZBSDSxpTwjDgHLrvmz4AocAG4BAlZwGGBBWXICuuNvpdIK5BIJKaI4U3vybPL9SN5kJpOn38ubWY2NAQAAAAAAAAAAAAAAAKpzIf4sWeY/47TzUC+gMep5qBfQGPU81AtojHoeQy+4qoa463LZBnlsQ3xrQ/yalvPyJn2Wjo32u9p5qBewwE5mE+fjK+vlx2n/Quvj4ck5k9nEVKaeh3oBc+lf77y8cCEeD7hFHKfvbE9uXDKVqOehXoAxm87LAxvk85nv3T5+sz4+NLu755rPo/ZDqfSh5wYs6+OHZT4bc1XPV7uAs/3j5d3WNN4yxmz8pb6NdMyFuEdDRm+IfLQh3km3sSVuCZvWx7vWx30mpP5EfLdenlyL8XxuIhePp+9YL0/TNbq4ZQ29YO3zS7nGf696feoFdP57NGRkNCSDCWksoFVjQhpDQxpDQxpDQzJ4qHceUCkmJIOGdB5QKSYkg4Z0HlApJiSDhnQeUCkmpDE0pDE0pDE0pDE0JIOHeucBlWJCMmhI5wGVYkIyaEjnAZViQjJoSOcBlWJCGkNDGkNDGkNDGkNDMniodx5QKSYkg4Z0HlDzE7L4hdyqfb2llpeD9OLmWV76vDqbXZi/9HkwRm3V89UuYMiyPu5bL/eWfS16ayr3eS16xIa4P2tveyq3T9s4IB1zIb5fRS1rPSFuHbbWGHrB2ucvvfmMl09rsflM8wXMpS2WXJDng7Zn8nLkQnx2xd+8aCpRz0O9gAV2KjvOy8uTTcpOv5UdnpwzlR1TmXoe6gX8a0OzII9+b+sXv6TlvLxOn9XcsKy5PMZ+6PXGaeehXkBj1PNQL6Ax6nmoF9AY8gAAAAAAAAAAAABgRvMLvkyl6hXnhOwAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeldingAndCutting);
export default __webpack_public_path__ + "static/media/weldingAndCutting.8711da4e8c57ff764c98daf00dd8dfc1.svg";
export { ForwardRef as ReactComponent };